// extracted by mini-css-extract-plugin
export default {"logoWrapper":"_Logo_logoWrapper__OKAsz","logo":"_Logo_logo__fdY6O"};